import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import CustomNavbar from "./CustomNavbar";
import Sidebar from "./Sidebar";
import "./ShellLayout.css";

function PrivateLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <div className="grange-shell">
<Sidebar
  isOpen={isSidebarOpen}
  onClose={() => setIsSidebarOpen(false)}
/>
      <div className="grange-shell-main">
        <CustomNavbar onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)} />

        <main className="grange-shell-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default PrivateLayout;
